import { Collection, CollectionType } from 'api'
import { NotificationType } from 'store/notification'
import { Translation } from 'locale'
import { ModalConsumerProps } from '../modal'
import { isEmpty, isEqual } from 'lodash'
import { Nullable } from 'utils'

export type ConfirmAddMatchingToExistingResponse = {
  cancelled: boolean
  matchedCollectionId?: string
}

export const confirmAddMatchingToExisting = async (
  showDialog: ModalConsumerProps['showDialog'],
  availableCollections: Collection[],
  newCollectionName: string | null,
  newCollectionType: CollectionType | null
): Promise<ConfirmAddMatchingToExistingResponse> => {
  if (newCollectionName && newCollectionType === CollectionType.SEND_INDIVIDUALLY) {
    const matchingCollectionNameId = availableCollections.find(
      collection => collection.name === newCollectionName && collection.type === CollectionType.SEND_INDIVIDUALLY
    )?.id

    if (matchingCollectionNameId) {
      const dialogArgs = {
        type: NotificationType.Confirm,
        title: Translation.SC_COLLECTION_NAME_ALREADY_EXISTS,
        message: Translation.SC_FORCE_ADD_TO_EXISTING_COLLECTION,
        messageArgs: {
          collectionName: newCollectionName
        },
        buttons: [Translation.TC_BUTTON_CANCEL, Translation.TC_BUTTON_OK],
        cancelButton: Translation.TC_BUTTON_CANCEL,
        defaultButton: Translation.TC_BUTTON_OK
      }

      const dialogResult = await showDialog(dialogArgs)

      return {
        matchedCollectionId: dialogResult === Translation.TC_BUTTON_OK && matchingCollectionNameId ? matchingCollectionNameId : undefined,
        cancelled: dialogResult === Translation.TC_BUTTON_CANCEL
      }
    }
  }

  return { cancelled: false }
}

export const createCollectionByCounterpartiesFilter = (counterpartyIds: string[]) => (collection: Collection): boolean =>
  isEmpty(counterpartyIds) || isEqual(collection.counterpartyIds.sort(), counterpartyIds.sort())

export const createCollectionByCollectionTypeFilter = (collectionType: Nullable<CollectionType>) => (collection: Collection) =>
  !collectionType || collection.type === collectionType

export const createCollectionByCollectionTypesFilter = (collectionTypes: CollectionType[] | null | undefined) => (collection: Collection) =>
  !collectionTypes || collectionTypes.some(type => type === collection.type)
